import '.ek{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.el{padding-left:1.5rem;}.ssr-plugin'
import '.em{margin:1rem 0;}.ssr-plugin'
import '.en{color:var(--gray-700);}.ssr-plugin'
import '.eo{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="ek el em en eo"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
